import React from "react";
import { Card, Box, Typography } from "@mui/material";
import useFetchVersions from "../utils/customHookVersions";

const TotalCard = ({ total, subtitle = "", size = 100, onClick }) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        width: size+78,
        height: size,
        p: "19px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        borderRadius: 2,
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick ? {
          boxShadow: 3,
          transform: "scale(1.02)",
          transition: "all 0.2s ease-in-out",
        } : {},
      }}
    >
      <Typography
        variant="h4"
        sx={{
          m: -1,
          marginLeft:0,
          flexGrow: 1,
          lineHeight: 1.6,
        }}
      >
        {total}
      </Typography>

      {subtitle && (
        <Typography
          variant="subtitle2"
          sx={{
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Card>
  );
};
export default TotalCard;
